<template>
  <div id="app"
    class="privacy-policy page-template-default page page-id-3 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
    <HeadNav selectedLanguage="en" page="about-us" :gotodownload="gotodownload" :apk="apk" />

    <div id="page" class="site grid-container container hfeed">
      <div id="content" class="site-content">
        <div id="primary" class="content-area">
          <main id="maincontent" class="site-main">
            <article id="post-3" class="post-3 page type-page status-publish">
              <div class="inside-article">
                <header class="entry-header section-content" aria-label="Content">
                  <h1 class="entry-title" itemprop="headline">
                    Terms of Use
                  </h1>
                </header>

                <div class="section-content" itemprop="text">
                 <ul>
                  <li>
                    <strong>Informational Purpose</strong>: All content provided on this website is for educational and informational purposes only.
                  </li>
                  
                  <li> <strong>No Ownership</strong>: We do not own or develop GBWhatsApp. All credits go to the original developers.</li>
                  <li> <strong>Safe Downloads</strong>: We strive to provide safe and verified download links, but users should proceed at their own discretion.</li>
                  <li> <strong>No Responsibility</strong>: We are not responsible for any bans, data loss, or other issues resulting from the use of GBWhatsApp.</li>
                  <li> <strong>User Responsibility</strong>: By downloading GBWhatsApp from our site, you agree that you are solely responsible for any consequences that may occur.</li>
                 </ul>

                  <p>
                    If you do not agree with these terms, please refrain from using our website.
                  </p>
                </div>

                <div style="height: 20px" aria-hidden="true" class="wp-block-spacer" />
              </div>
            </article>
          </main>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'About Us',
  components: {
    HeadNav,
  },
  data() {
    return {
      pageName: 'about-us',
      showapk: false,
      apk: null,
      from: 'gb',
      filename: 'gb',
    };
  },

  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {

    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
      // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      console.log(this.apk);
      // this.showapk = true
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$--group-option-flex: 0 calc(1 / 5) * 100%!default;
h2 {
  margin-top: 20px !important;
}

.section-content {
  margin-top: 0;
  margin-bottom: 15px;
}

#maincontent {
  margin-top: 22px !important;
}
</style>
